<script>
  import { formatStr } from '../utils/format.js';
  import { colorScale } from '../utils/color.js';

  import Photo from './Photo.svelte';
  export let precinct;
  export let data;
  export let nbhCandidate1,
             nbhCandidate2,
             nbhCandidate3,
             nbhCandidate4,
             nbhCandidate1Pct,
             nbhCandidate2Pct,
             nbhCandidate3Pct,
             nbhCandidate4Pct,
             nbhTotalVotes;
</script>

{#if typeof data.total_votes !== 'undefined'}
  <div class="detail-split">
    {#if data.total_votes > 10}
      <div class="text">
        <div class="detail-location-label precinct">
          <p class="detail-location-label__desc precinct">Your precinct</p>
          <p class="detail-location-label__place">{precinct}</p>
          <p class="detail-location-label__votes">{data.total_votes.toLocaleString()} votes</p>
        </div>
        <table class="results">
          <tr class="candidate-1">
              <td class="candidate-color" style="background-color:{colorScale(data.candidate_name_1)}"></td>
              <td>{data.candidate_name_1}</td>
              <td class="pct">{Math.round(data.candidate_pct_1 * 100)}%</td>
          </tr>
          <tr class="candidate-2">
            <td class="candidate-color" style="background-color:{colorScale(data.candidate_name_2)}"></td>
            <td>{data.candidate_name_2}</td>
            <td class="pct">{Math.round(data.candidate_pct_2 * 100)}%</td>
          </tr>
          <tr class="candidate-3">
            <td class="candidate-color" style="background-color:{colorScale(data.candidate_name_3)}"></td>
            <td>{data.candidate_name_3}</td>
            <td class="pct">{Math.round(data.candidate_pct_3 * 100)}%</td>
          </tr>
          <tr class="candidate-4">
            <td class="candidate-color" style="background-color:{colorScale(data.candidate_name_4)}"></td>
            <td>{data.candidate_name_4}</td>
            <td class="pct">{Math.round(data.candidate_pct_4 * 100)}%</td>
          </tr>
        </table>
      </div>
    {:else}
      <div class="text">
        <p class="detail-location-label__desc precinct">Your precinct</p>
        <p class="detail-location-label__place">{precinct}</p>
        <p class="detail-location-label__votes">{data.total_votes.toLocaleString()} votes</p>
        <div class="results">To protect privacy, the County does not provide information about precincts with fewer than 10 votes.</div> 
      </div>
    {/if}
    <div class="text">
      <div class="detail-location-label">
        <p class="detail-location-label__desc neighborhood">Your neighborhood</p>
        <p class="detail-location-label__place">{data.neighborhood}</p>
        <p class="detail-location-label__votes">{nbhTotalVotes.toLocaleString()} votes</p>
      </div>
      <table class="results">
        <tr class="candidate-1">
          <td class="candidate-color" style="background-color:{colorScale(nbhCandidate1)}"></td>
          <td>{nbhCandidate1}</td>
            <td class="pct">{Math.round(nbhCandidate1Pct * 100)}%</td>
        </tr>
        <tr class="candidate-2">
          <td class="candidate-color" style="background-color:{colorScale(nbhCandidate2)}"></td>
          <td>{nbhCandidate2}</td>
            <td class="pct">{Math.round(nbhCandidate2Pct * 100)}%</td>
        </tr>
        <tr class="candidate-3">
          <td class="candidate-color" style="background-color:{colorScale(nbhCandidate3)}"></td>
          <td>{nbhCandidate3}</td>
            <td class="pct">{Math.round(nbhCandidate3Pct * 100)}%</td>
        </tr>
        <tr class="candidate-4">
          <td class="candidate-color" style="background-color:{colorScale(nbhCandidate4)}"></td>
          <td>{nbhCandidate4}</td>
            <td class="pct">{Math.round(nbhCandidate4Pct * 100)}%</td>
        </tr>
      </table>
    </div>
  </div>
{:else}
  <div class="results">
    <div>Votes have not yet been recorded in this area.</div> 
  </div>
{/if}

  
